import type { ComplexClassName } from '../../types/common'

export const AvatarSize = {
  'xxs': 'xxs',
  'xs': 'xs',
  'sm': 'sm',
  'md': 'md',
  'lg': 'lg',
  'xl': 'xl',
  '2xl': '2xl',
} as const

export const AvatarStatus = {
  default: 'default',
  ready: 'ready',
  pending: 'pending',
} as const

export const AvatarVariant = {
  default: 'default',
  colored: 'colored',
} as const

export interface AvatarProps {
  name?: string
  size?: keyof typeof AvatarSize
  status?: keyof typeof AvatarStatus
  variant?: keyof typeof AvatarVariant
  avatarClass?: ComplexClassName
  src?: string
  alt?: string
}
